import { ComponentView } from "binder";
import { PopupViewModel, Position } from "../popup/popup-viewModel";
import { ITemplateSelector } from "../templateSelector";
import { TooltipViewModel } from "./tooltip-viewModel"

export class TooltipView extends ComponentView<TooltipViewModel>{
    GetViewUniqueId(): string {
        return "V-A40827BE-1D94-441D-92B6-4FA53821697E"
    }
    loadHtml(): string {
        let element = require('./tooltip.html').default;
        let style = require('./tooltip.less');
        return element;
    }
    constructor() {
       super();
    }

    private _popupElement:HTMLElement;
    public set popup(v: PopupViewModel) { this._popup = v; } public get popup(): PopupViewModel { return this._popup;} private _popup: PopupViewModel;
    public set thisElement(v: HTMLElement) { this._thisElement = v; } public get thisElement(): HTMLElement { return this._thisElement;} private _thisElement: HTMLElement;

    onRenderCompleted(){
        super.onRenderCompleted();
        this._popupElement=(<HTMLElement>this.firstlevelElement).querySelector('.v-a40827be-1d94-441d-92b6-4fa53821697e-tooltip-popup');
        this.popup = (<any>this._popupElement).binderRelatedView.dataContext;
        this.thisElement = <HTMLElement>this.firstlevelElement;
    }
    append(...nodes: (Node | string)[]): void{
        nodes.forEach(node=>{
            if(node instanceof HTMLElement && node.classList.contains('tooltip'))
                (<any>this._popupElement).binderRelatedView.append(...node.childNodes);
            else
                (<HTMLElement>this.firstlevelElement).append(node);
        })
    }
    public set isMouseOver(v: boolean) { this._isMouseOver = v; } public get isMouseOver(): boolean { return this._isMouseOver;} private _isMouseOver: boolean;
    
    onover(){
        this.isMouseOver = true;
    }
    onout(){
        this.isMouseOver = false;
    }
}
